<template>
  <MembershipOverlayCard
    :title="title"
    :message="message"
    :primary-action-label="primaryActionLabel"
    :secondary-action-label="secondaryActionLabel"
    dismiss-on-backdrop
    @primary="onPrimary"
    @secondary="dismiss"
    @backdrop="dismiss"
  />
</template>

<script setup>
import { modalController } from '@ionic/vue';
import MembershipOverlayCard from '@/components/partner/MembershipOverlayCard.vue';
import {
  HIGHLIGHT_PREMIUM_REQUIRED_ACTION,
  HIGHLIGHT_PREMIUM_REQUIRED_MESSAGE,
  HIGHLIGHT_PREMIUM_REQUIRED_TITLE,
} from '@/components/partner/partnerMembershipCopy.js';

const props = defineProps({
  title: { type: String, default: HIGHLIGHT_PREMIUM_REQUIRED_TITLE },
  message: { type: String, default: HIGHLIGHT_PREMIUM_REQUIRED_MESSAGE },
  primaryActionLabel: { type: String, default: HIGHLIGHT_PREMIUM_REQUIRED_ACTION },
  secondaryActionLabel: { type: String, default: 'Abbrechen' },
  confirmRole: { type: String, default: 'confirm' },
});

const dismiss = () => modalController.dismiss(null, 'cancel');

const onPrimary = () => {
  modalController.dismiss({ confirmed: true }, props.confirmRole);
};
</script>
